export default {
  backship: {
    id: 'bo_sellers-orders-components-orders_table-backship',
    defaultMessage: 'Backship',
  },
  price: {
    id: 'bo_sellers-orders-components-orders_table-price',
    defaultMessage: 'Price',
  },
  free: {
    id: 'bo_sellers-orders-components-orders_table-free',
    defaultMessage: 'Free',
  },
} as const
